import {Component, inject, input, OnInit} from '@angular/core';
import {HsFormsService} from '@core/services/hs-forms.service';

@Component({
  selector: 'app-storyblok-hubspot-form',
  templateUrl: './storyblok-hubspot-form.component.html',
  styleUrls: ['./storyblok-hubspot-form.component.scss'],
  imports: []
})
export class StoryblokHubspotFormComponent implements OnInit {
  private hsFormsService = inject(HsFormsService);


  readonly portalId = input.required<string>();
  readonly formId = input.required<string>();

  ngOnInit(): void {
    this.hsFormsService.addForm(this.portalId(), this.formId(), '#formId-' + this.formId());
  }

}
